// src/environments/environment.ts
export const environment = {
    production: false,
    apiBaseUrl: 'https://asa-portal-demo-59824082974.us-east1.run.app/'
}; 